import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { SKILL_REQUESTS_API } from '../constants/skill-api.constants';
import {
  SkillRequestCreateRequest,
  SkillRequestResponse,
} from '../models/skill-learning.model';

@Injectable()
export class SkillRequestApiService {

  constructor(private http: HttpClient) {}

  createRequest(body: SkillRequestCreateRequest): Observable<SkillRequestResponse> {
    return this.http.post<SkillRequestResponse>(SKILL_REQUESTS_API.BASE, body);
  }

  fetchMyRequests(): Observable<SkillRequestResponse[]> {
    return this.http.get<SkillRequestResponse[]>(SKILL_REQUESTS_API.MY);
  }

  fetchAllRequests(): Observable<SkillRequestResponse[]> {
    return this.http.get<SkillRequestResponse[]>(SKILL_REQUESTS_API.BASE);
  }

  approveRequest(id: string): Observable<SkillRequestResponse> {
    return this.http.post<SkillRequestResponse>(SKILL_REQUESTS_API.APPROVE(id), {});
  }

  rejectRequest(id: string): Observable<SkillRequestResponse> {
    return this.http.post<SkillRequestResponse>(SKILL_REQUESTS_API.REJECT(id), {});
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-request-api.service.ts